import { Drawer as MuiDrawer } from "@mui/material";

const drawerStyle = {
  width: "0px",
  flexShrink: 0,
  zIndex: 0,
  "& .MuiDrawer-paper": {
    width: 400,
    border: "none",
    height: "100vh",
    position: "relative",
  },
};

const Drawer = (props) => {
  const { children, openDrawer } = props;

  return (
    <MuiDrawer
      sx={drawerStyle}
      variant="persistent"
      anchor="left"
      open={openDrawer}
    >
      {children}
    </MuiDrawer>
  );
};

export default Drawer;
